import { isNone } from '@ember/utils';
import ApplicationSerializer from './application';

export default ApplicationSerializer.extend({
  isNewSerializerAPI: true,

  normalize(type, hash) {
    if (isNone(hash.body)) {
      hash.body = '';
    }

    return this._super(...arguments);
  },
});
